import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { apiClient } from "sessions/server";

export const Verification = () => {
    const { token } = useParams();
    const [status, setStatus] = useState("processing"); // processing, success, error
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        apiClient
            .post(`/users/subscribe/verify/`, { token: token })
            .then((response) => {
                if (String(response.status).startsWith("20")) {
                    setStatus("success");
                } else {
                    setStatus("error");
                    setErrorMessage(
                        response.data?.message ||
                            "Something went wrong. Please try again later.",
                    );
                }
            })
            .catch((error) => {
                setStatus("error");
                setErrorMessage(
                    error.response?.data?.message ||
                        error.message ||
                        "Something went wrong. Please try again later.",
                );
            });
    }, [token]);

    if (status === "processing") {
        return (
            <section className="container text-box">
                <h2 className="section-title">Processing...</h2>
                <p className="section-description">
                    Please wait while we verify your email address.
                </p>
            </section>
        );
    }

    if (status === "error") {
        return (
            <section className="container text-box">
                <h2 className="section-title">Error</h2>
                <p className="section-description">{errorMessage}</p>
            </section>
        );
    }

    return (
        <section className="container text-box">
            <h2 className="section-title">Verified</h2>
            <p className="section-description">
                Your email address has been successfully verified. Thank you for
                confirming your subscription! Enjoy your full access to the{" "}
                <a href="/goodies">3D Printable Prototypes</a>.
            </p>
        </section>
    );
};
